export default () => ({
  getluckyActivityInfo: {}, // 一元购活动信息
  getluckySkuInfo: {}, // 一元购sku
  getluckyPaymentInfo: [], // 一元购payment
  getluckyPartNum: {}, // 一元购活动期数信息
  getluckyWinRecord: {}, // 一元购 中奖记录
})
